<div [formGroup]="form">

    <kal-form-field *ngFor="let line of addressLines | keyvalue">
        <kal-input [formControlName]="line.key"
                   [label]="line.value">
        </kal-input>
    </kal-form-field>

    <app-shared-city-picker formControlName="Ville"></app-shared-city-picker>

</div>
